import { Injectable } from '@angular/core'
import { BaseModelService } from './base-model.service'
import { AbTest } from './ab-test.model'
import { AbTestSerializer } from 'serializers'
import { Observable } from 'rxjs/Observable'

@Injectable()
export class AbTestService extends BaseModelService<AbTest> {
  constructor() {
    super()
    this.configure({
      basePath:  'ab_tests',
      key:       'abTest',
      pluralKey: 'abTests',
      serializer: AbTestSerializer
    })
  }

  start(obj: AbTest): Observable<Object> {
    let url = this.buildUrl(obj.id, 'start')
    return this.patch(url)
  }

  finish(obj: AbTest): Observable<Object> {
    let url = this.buildUrl(obj.id, 'finish')
    return this.patch(url)
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/ab-test.service.ts